import { render, staticRenderFns } from "./LogoExplicaeFree.vue?vue&type=template&id=dab47c12&scoped=true"
import script from "./LogoExplicaeFree.vue?vue&type=script&lang=ts"
export * from "./LogoExplicaeFree.vue?vue&type=script&lang=ts"
import style0 from "./LogoExplicaeFree.vue?vue&type=style&index=0&id=dab47c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab47c12",
  null
  
)

export default component.exports